import Vue from 'vue';

export default [
    // Legacy
    {
        pathId: 'fls',
        component: 'conferences-legacy',
        title: 'Conferences (Legacy)',
        icon: 'fa-presentation',
        size: 'sm',
        loading: true
    },
    {
        pathId: 'fl',
        component: 'conference-legacy',
        title: 'Conference (Legacy)',
        icon: 'fa-presentation',
        size: 'sm',
        props: ['confId'],
        loading: true
    },
    {
        pathId: 'fle',
        component: 'edit-config-legacy',
        title: 'Edit Configuration (Legacy)',
        icon: 'fa-pencil',
        size: 'md',
        props: ['confId', 'configId'],
        loading: true
    },

    // New
    {
        pathId: 'fs',
        component: 'conferences',
        title: 'Conferences',
        icon: 'fa-presentation',
        size: 'md',
        loading: true
    }, {
        pathId: 'f',
        component: 'conference',
        title: 'Conference',
        icon: 'fa-presentation',
        size: 'md',
        props: ['confId'],
        loading: true
    }, {
        pathId: 'fn',
        component: 'new-conference',
        title: 'New Conference',
        icon: 'fa-plus',
        size: 'lg',
        loading: true
    }, {
        pathId: 'fe',
        component: 'edit-conference',
        title: 'Edit Conference',
        icon: 'fa-pencil',
        size: 'lg',
        props: ['confId'],
        loading: true
    }, {
        pathId: 'frs',
        component: 'registrations',
        title: 'Registrations',
        icon: 'fa-users',
        size: 'sm',
        props: ['confId', 'type', 'query', 'typeId'],
        // loading: true
    }, {
        pathId: 'fr',
        component: 'registration',
        title: 'Registration',
        icon: 'fa-user',
        size: 'md',
        props: ['confId', 'regId'],
        loading: true
    }, {
        pathId: 'fre',
        component: 'edit-registration',
        title: 'Edit Registration',
        icon: 'fa-pencil',
        size: 'md',
        props: ['confId', 'regId'],
        loading: true
    }, {
        pathId: 'frrd',
        component: 'refund-registration',
        title: 'Refund/Delete Registration',
        icon: 'fa-times',
        size: 'sm',
        props: ['confId', 'regId'],
        loading: true
    }, {
        pathId: 'registration-search',
        component: 'registration-search',
        title: 'Registration Search',
        icon: 'fa-search',
        size: 'sm',
        props: ['query', 'confId', 'type'],
        loading: true
    }, {
        pathId: 'fsc',
        component: 'conf-scheduler',
        title: 'Session Scheduler',
        icon: 'fa-calendar-lines-pen',
        size: 'full',
        props: ['confId'],
        loading: true
    }, {
        pathId: 'fsss',
        component: 'conf-sessions',
        title: 'Sessions',
        icon: 'fa-users-class',
        size: 'md',
        props: ['confId'],
        loading: true
    }, {
        pathId: 'fss',
        component: 'conf-session',
        title: 'Session',
        icon: 'fa-users-class',
        size: 'md',
        props: ['confId', 'sessionId'],
        loading: true
    }, {
        pathId: 'fssn',
        component: 'conf-new-session',
        title: 'New Session',
        icon: 'fa-plus',
        size: 'lg',
        props: ['confId']
    }, {
        pathId: 'fsse',
        component: 'conf-edit-session',
        title: 'Session',
        icon: 'fa-users-class',
        size: 'lg',
        props: ['confId', 'sessionId'],
        loading: true
    }, {
        pathId: 'fssp',
        component: 'conf-session-participants',
        title: 'Session Participants',
        icon: 'fa-users',
        size: 'sm',
        props: ['confId', 'sessionId'],
        loading: true
    }, {
        pathId: 'rmc-ssqs',
        component: 'rmc-session-survey-questions',
        title: 'Survey Questions',
        icon: 'fa-question-circle',
        size: 'sm',
        props: ['confId', 'sessionId'],
        loading: true
    }, {
        pathId: 'rmc-ssqn',
        component: 'rmc-new-session-survey-question',
        title: 'New Survey Question',
        icon: 'fa-plus',
        size: 'md',
        props: ['sessionId']
    }, {
        pathId: 'rmc-ssqe',
        component: 'rmc-edit-session-survey-question',
        title: 'Edit Survey Question',
        icon: 'fa-pencil',
        size: 'md',
        props: ['sessionId', 'questionId'],
        loading: true
    }, {
        pathId: 'fts',
        component: 'conf-reg-types',
        title: 'Registration Types/Fees',
        icon: 'fa-people-group',
        size: 'sm',
        props: ['confId'],
        loading: true
    }, {
        pathId: 'ftn',
        component: 'conf-new-type',
        title: 'New Registration Type/Fee',
        icon: 'fa-plus',
        props: ['confId'],
        size: 'md',
        loading: true
    }, {
        pathId: 'fte',
        component: 'conf-edit-type',
        title: 'Edit Registration Type/Fee',
        icon: 'fa-pencil',
        props: ['typeId', 'confId'],
        size: 'md'
    }, {
        pathId: 'fsgs',
        component: 'conf-groups',
        title: 'Session Groups',
        icon: 'fa-layer-group',
        size: 'sm',
        props: ['confId'],
        loading: true
    }, {
        pathId: 'fsgn',
        component: 'conf-new-group',
        title: 'New Session Group',
        icon: 'fa-plus',
        props: ['confId'],
        size: 'md',
        loading: true
    }, {
        pathId: 'fsge',
        component: 'conf-edit-group',
        title: 'Edit Session Group',
        icon: 'fa-pencil',
        props: ['groupId', 'confId'],
        size: 'md'
    }, {
        pathId: 'fsts',
        component: 'conf-tracks',
        title: 'Session Tracks',
        icon: 'fa-code-branch',
        size: 'sm',
        props: ['confId'],
        loading: true
    }, {
        pathId: 'fstn',
        component: 'conf-new-track',
        title: 'New Session Group',
        icon: 'fa-plus',
        props: ['confId'],
        size: 'md'
    }, {
        pathId: 'fste',
        component: 'conf-edit-track',
        title: 'Edit Session Group',
        icon: 'fa-pencil',
        props: ['trackId', 'confId'],
        size: 'md'
    }, {
        pathId: 'fqs',
        component: 'conf-questions',
        title: 'Registration Questions',
        icon: 'fa-question-circle',
        size: 'sm',
        props: ['confId'],
        loading: true
    }, {
        pathId: 'fqn',
        component: 'conf-new-question',
        title: 'New Registration Question',
        icon: 'fa-plus',
        size: 'md',
        props: ['confId']
    }, {
        pathId: 'fqe',
        component: 'conf-edit-question',
        title: 'Edit Registration Question',
        icon: 'fa-pencil',
        size: 'md',
        props: ['confId', 'questionId']
    }, {
        pathId: 'fds',
        component: 'conf-discounts',
        title: 'Discounts',
        icon: 'fa-tags',
        size: 'sm',
        props: ['confId'],
        loading: true
    }, {
        pathId: 'fdn',
        component: 'conf-new-discount',
        title: 'New Registration Discount',
        icon: 'fa-plus',
        props: ['confId'],
        size: 'md'
    }, {
        pathId: 'fde',
        component: 'conf-edit-discount',
        title: 'Edit Registration Discount',
        icon: 'fa-pencil',
        props: ['confId', 'discountId'],
        size: 'md',
        loading: true
    }, {
        pathId: 'fas',
        component: 'conf-applications',
        title: 'Certification Applications',
        icon: 'fa-file-certificate',
        size: 'md',
        props: ['confId'],
        loading: true
    }, {
        pathId: 'fa',
        component: 'conf-app',
        title: 'Application',
        icon: 'fa-file-certificate',
        size: 'md',
        props: ['confId', 'appId'],
        loading: true
    }, {
        pathId: 'faai',
        component: 'conf-app-summary',
        title: 'Application Evaluation Summary',
        icon: 'fa-sparkles',
        size: 'xl',
        props: ['confId', 'appId'],
        loading: true
    }, {
        pathId: 'fae',
        component: 'conf-edit-app',
        title: 'Edit Certification Application',
        icon: 'fa-file-certificate',
        size: 'lg',
        props: ['confId', 'appId'],
        loading: true
    }, {
        pathId: 'faus',
        component: 'conf-assigned-users',
        title: 'Assigned Users',
        icon: 'fa-user-check',
        size: 'md',
        props: ['confId'],
        loading: true
    }, {
        pathId: 'fcc',
        component: 'conf-communicate',
        title: 'Communicate',
        icon: 'fa-comment',
        size: 'lg',
        props: ['confId', 'type'],
        loading: true
    }
];

Vue.component('conferences-legacy', () => import('@/cards/conferences/legacy/Conferences'));
Vue.component('conference-legacy', () => import('@/cards/conferences/legacy/Conference'));
Vue.component('edit-config-legacy', () => import('@/cards/conferences/legacy/EditConfig'));

// New
Vue.component('conferences', () => import('@/cards/conferences/Conferences'));
Vue.component('conference', () => import('@/cards/conferences/Conference'));
Vue.component('new-conference', () => import('@/cards/conferences/NewConference'));
Vue.component('edit-conference', () => import('@/cards/conferences/EditConference'));
Vue.component('conf-scheduler', () => import('@/cards/conferences/sessions/Scheduler'));
Vue.component('conf-sessions', () => import('@/cards/conferences/sessions/Sessions'));
Vue.component('conf-session', () => import('@/cards/conferences/sessions/Session'));
Vue.component('conf-new-session', () => import('@/cards/conferences/sessions/NewSession'));
Vue.component('conf-edit-session', () => import('@/cards/conferences/sessions/EditSession'));
Vue.component('conf-session-participants', () => import('@/cards/conferences/sessions/SessionParticipants'));
// Vue.component('rmc-session-survey-questions', () => import('@/cards/conferences/SessionSurveyQuestions'));
// Vue.component('rmc-new-session-survey-question', () => import('@/cards/conferences/NewSessionSurveyQuestion'));
// Vue.component('rmc-edit-session-survey-question', () => import('@/cards/conferences/EditSessionSurveyQuestion'));
Vue.component('conf-reg-types', () => import('@/cards/conferences/types/Types'));
Vue.component('conf-new-type', () => import('@/cards/conferences/types/NewType'));
Vue.component('conf-edit-type', () => import('@/cards/conferences/types/EditType'));
Vue.component('conf-tracks', () => import('@/cards/conferences/sessions/tracks/Tracks'));
Vue.component('conf-new-track', () => import('@/cards/conferences/sessions/tracks/NewTrack'));
Vue.component('conf-edit-track', () => import('@/cards/conferences/sessions/tracks/EditTrack'));
Vue.component('conf-groups', () => import('@/cards/conferences/sessions/groups/Groups'));
Vue.component('conf-new-group', () => import('@/cards/conferences/sessions/groups/NewGroup'));
Vue.component('conf-edit-group', () => import('@/cards/conferences/sessions/groups/EditGroup'));
Vue.component('registrations', () => import('@/cards/conferences/registrations/Registrations'));
Vue.component('registration', () => import('@/cards/conferences/registrations/Registration'));
Vue.component('edit-registration', () => import('@/cards/conferences/registrations/EditRegistration'));
Vue.component('refund-registration', () => import('@/cards/conferences/registrations/Refund'));
Vue.component('registration-search', () => import('@/cards/conferences/registrations/RegistrationSearch'));
Vue.component('conf-questions', () => import('@/cards/conferences/questions/Questions'));
Vue.component('conf-new-question', () => import('@/cards/conferences/questions/NewQuestion'));
Vue.component('conf-edit-question', () => import('@/cards/conferences/questions/EditQuestion'));
Vue.component('conf-discounts', () => import('@/cards/conferences/discounts/Discounts'));
Vue.component('conf-new-discount', () => import('@/cards/conferences/discounts/NewDiscount'));
Vue.component('conf-edit-discount', () => import('@/cards/conferences/discounts/EditDiscount'));
Vue.component('conf-applications', () => import('@/cards/conferences/applications/Applications'));
Vue.component('conf-app', () => import('@/cards/conferences/applications/Application'));
Vue.component('conf-app-summary', () => import('@/cards/conferences/applications/AiSummary'));
Vue.component('conf-edit-app', () => import('@/cards/conferences/applications/EditApplication'));
Vue.component('conf-assigned-users', () => import('@/cards/conferences/assigned_users/AssignedUsers'));
Vue.component('conf-communicate', () => import('@/cards/conferences/Communicate'));
